import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { contentViewerSelectors } from '@tabeeb/modules/contentViewer'
import { getIsContentReadonly } from '@tabeeb/modules/readonlyWhiteboard/selectors'

import Hotspot from '../components/Hotspot'
import HotspotDialogContainer from './HotspotDialogContainer'

import AnnotationContainer from './AnnotationContainer'
import * as annotationActions from '../actions'
import * as annotationsSelectors from '../selectors'

class HotspotContainer extends AnnotationContainer {
  constructor(props) {
    super(props)

    this.selectionProps = {
      onClick: this._handleSelect,
    }

    this.hoverProps = {
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave,
    }

    this.contextMenuProps = {
      onContextMenu: this._handleContextMenu,
    }

    this.dragAndDropProps = {
      draggable: !props.isReadonlyView,
      dragBoundFunc: this._handleDragBound,
      onDragStart: this._handleDragStart,
      onDragMove: this._handleDragMove,
      onDragEnd: this._handleEndUpdate,
    }
  }

  _handleSelect = (e) => {
    const { isReadonlyView } = this.props
    if (isReadonlyView) {
      return
    }

    if (e.evt.which !== 1) {
      return
    }

    const { annotation } = this.state

    const {
      annotationActions: { openHotspotDialog },
    } = this.props

    openHotspotDialog({ annotationId: annotation.Id })
  }

  _handleDragMove = (e) => {
    const { target } = e
    const { annotation } = this.state

    const newAnnotation = {
      ...annotation,
      Anchor: {
        X: target.x(),
        Y: target.y(),
      },
    }
    this.setState({ annotation: newAnnotation })
  }

  render() {
    const { opened, contentScale, opacity, parentHovered, parentSelected } = this.props
    const { hovered, selected, annotation } = this.state

    let position = null
    if (opened) {
      position = this.getElementAbsolutePosition()
    }

    const props = {
      annotation,
      annotationRef: this.annotationRef,
      opacity,
      hovered: opened || hovered || parentHovered,
      selected: selected || parentSelected,
      contentScale,
      hoverProps: this.hoverProps,
      selectionProps: this.selectionProps,
      contextMenuProps: this.contextMenuProps,
      dragAndDropProps: this.dragAndDropProps,
    }

    return (
      <>
        {opened && position && <HotspotDialogContainer Id={annotation.Id} x={position.x} y={position.y} />}
        <Hotspot {...props} />
      </>
    )
  }
}

HotspotContainer.propTypes = {
  opened: PropTypes.bool.isRequired,
  contentScale: PropTypes.number.isRequired,
  currentAnnotation: PropTypes.object.isRequired,
}

const mapStateToProps = (state, { Id }) => {
  return {
    contentSize: contentViewerSelectors.getContentSize(state),
    scale: contentViewerSelectors.getScale(state),
    contentScale: contentViewerSelectors.getContentScale(state),
    opened: annotationsSelectors.getHotspotDialogAnnotationId(state) === Id,
    opacity: annotationsSelectors.getAnnotationOpacity(state, { Id }),
    selected: annotationsSelectors.getIsAnnotationSelected(state, { Id }),
    currentAnnotation: annotationsSelectors.getAnnotationById(state, { Id }),
    isReadonlyView: getIsContentReadonly(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    annotationActions: bindActionCreators(annotationActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotspotContainer)
